import {
    zodArrayOrStringArray,
    zodBooleanLike,
    zodStringLike,
} from '@dmp/shared/zod-utils';
import type { FilterDefinition, FilterDefinitions } from './types';

/**
 * Narrow the types of a filter definition. Ensures, for example that in `{ type: 'boolean' }`,
 * `boolean` is interpreted as a string literal and not a generic string.
 */
export function filters<T extends FilterDefinitions>(filters: T): T {
    return filters;
}

export function zodTypeFromFilter<T extends FilterDefinition>(filter: T) {
    switch (filter.type) {
        case 'boolean':
            return zodBooleanLike();

        case 'in':
            return zodArrayOrStringArray();

        default:
            return zodStringLike();
    }
}
